/**
 * Shared activity-category metadata (label/color) — mirrors backend ACTIVITY_CATEGORIES.
 */
export const CATEGORY_META = {
  prospecting: { label: 'Prospecting', color: '#3b82f6', money_action: true },
  cold_calling: { label: 'Cold Calling', color: '#10b981', money_action: true },
  follow_up: { label: 'Follow-Up', color: '#f59e0b', money_action: true },
  canvassing: { label: 'D2D Canvassing', color: '#f97316', money_action: true },
  demos: { label: 'Demos', color: '#8b5cf6', money_action: true },
  applications: { label: 'Applications', color: '#06b6d4', money_action: true },
  proposal_work: { label: 'Proposal Work', color: '#ec4899', money_action: true },
  admin: { label: 'Admin', color: '#64748b', money_action: false },
  marketing: { label: 'Marketing', color: '#d946ef', money_action: false },
  training: { label: 'Training', color: '#6366f1', money_action: false },
};
